import React, { useEffect, useState } from "react";



import { useKeycloak } from '@react-keycloak/web';
import { useFetchSocieteCompteQuery, useFetchSocietesByIdsQuery, useSocieteCompteUpdateMutation } from "../../../redux/slice/api/FO/societeApi";
import { IKeyValue } from "../../../models/interfaces/IKeyValue";
import { filterToQuery } from "../../../models/interfaces/IFilterMarque";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import CpntForm from "../../../components/forms/CpntForm";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import TextInput from "../../../components/forms/TextInput";
import { ModulesList, Type_Reponse_Message, TypeCompteSociete, validationMode } from "../../../config/helpers";
import { FRANCE_ET_ASSIMILES_IDS } from "../../../utils/helpers";
import { Button, Tab, Tabs } from "react-bootstrap";
import CpntFormSectionNavigation from "../../../components/forms/CpntFormSectionNavigation";
import { IFormOrganisation } from "../../../models/interfaces/IFormOrganisation";
import { getOrganisationSchema } from "../../../models/schema/OrganisationSchema";
import { useSirenValidation } from "../../../hooks/useSirenValidation";
import { yupResolver } from "@hookform/resolvers/yup";
import SelectInput from "../../../components/forms/SelectInput";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { filterToQuery as filterToQueryMessage } from "../../../models/interfaces/IFilterMessage";
import { dtoToFilter, getDefaultFilterMarque, IFilterMarque } from "../../../models/interfaces/IFilterMarque";
import MarquesFilter from "../components/MarquesFilter";
import { ILocation } from "../../../models/interfaces/ILocation";
import { ITitle } from "../../../models/interfaces/ITitle";
import CpntDataTable from "../../../components/dataTable/CpntDataTable";
import { useFetchPaysQuery, useFetchSecteurActiviteQuery } from "../../../redux/slice/api/staticData";
import { toast } from "react-toastify";
import CpntFacette from "../../../components/CpntFacette";
import { useFetchmessagesMarqueQuery } from "../../../redux/slice/api/FO/messageApi";
import { useNavigate } from "react-router-dom";
import { IFilterMessage } from "../../../models/interfaces/IFilterMessage";
//import { ISociete } from "../../../models/interfaces/ISociete";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";
import Label from "../../../components/forms/Label";
import CpntPagination from "../../../components/CpntPagination";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";

const PageMonOrganisation: React.FC = () => {

  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const hasResetFormRef = React.useRef<boolean>(false);
  
  // Référence pour l'erreur API SIREN
  const sirenApiErrorRef = React.useRef<string | null>(null);

  // Créer un resolver dynamique qui utilise la référence
  const dynamicResolver = React.useMemo(
    () => async (values: any, context: any, options: any) => {
      const schema = getOrganisationSchema(sirenApiErrorRef.current);
      return yupResolver(schema)(values, context, options);
    },
    []
  );

  
  //const navigate = useNavigate();

  const formMethodsOrganisation = useForm<IFormOrganisation | any>({
    mode: "all",
    reValidateMode: "onChange",
    resolver: dynamicResolver as any,
  });

  // setValue, setError, clearErrors,getValues
  const { handleSubmit:handleSubmitOrganisation,reset:resetOrganisation, watch, trigger, setValue } =
  formMethodsOrganisation;

  const watchIdPays = watch("IdPays");
  const watchSiren = watch("Siren");

  const compte = useSelector((state: RootState) => state.compte);
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();

  const { data: SocieteCompteResult, isFetching: SocieteCompteisFetching, error: SocieteCompteerror } = useFetchSocieteCompteQuery(null, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || !compte
  });

  // Hook de validation SIREN
  const { sirenApiError } = useSirenValidation({
    siren: watchSiren,
    isFranceOrAssimile: watchIdPays ? FRANCE_ET_ASSIMILES_IDS.includes(Number(watchIdPays)) : false,
    idSociete: SocieteCompteResult?.Societe?.IdSociete,
    setValue: setValue,
    trigger,
    raisonSocialeSirenFieldName: "RaisonSocialeSiren",
    raisonSocialeFieldName: "RaisonSociale",
    showToasts: true,
    fillRaisonSociale: false
  });

  // Mettre à jour la ref sirenApiError et re-valider quand elle change
  useEffect(() => {
    sirenApiErrorRef.current = sirenApiError || null;
    if (watchSiren) {
      // Re-vérifier la validation du champ Siren
      trigger("Siren");
    }
  }, [sirenApiError, watchSiren, trigger]);
  
  useEffect(() => {
    // Revalider le champ Siren quand IdPays change
    if (watchIdPays !== undefined) {
      trigger("Siren");
    }
  }, [watchIdPays, trigger]);

  // Appeler l'API SIREN au chargement si un SIREN existe
  useEffect(() => {
    if (isInitialized &&
        watchSiren && 
        watchSiren.length === 9 &&
        watchIdPays && 
        FRANCE_ET_ASSIMILES_IDS.includes(Number(watchIdPays))) {
      trigger("Siren");
    }
  }, [isInitialized, watchSiren, watchIdPays, trigger]);

  const onSubmitOrganisation: SubmitHandler<IFormOrganisation> = (data) => {
    // Si le pays n'est pas France ou assimilé, vider le SIREN et la raison sociale SIREN
    const isFrance = data.IdPays ? FRANCE_ET_ASSIMILES_IDS.includes(Number(data.IdPays)) : false;
    
    updateSociete({
      ...data,
      Siren: isFrance ? data.Siren : "", // Vider le SIREN si pas France
      RaisonSocialeSiren: isFrance ? data.RaisonSocialeSiren : "" // Vider la raison sociale SIREN si pas France
    });
  };

  const onErrorOrganisation = (errors: any) => {

  };
  const { data: pays } = useFetchPaysQuery();
  const { data: secteurActivites } = useFetchSecteurActiviteQuery();
  const [sourceTasks, setSourceTasks] = useState<IKeyValue[]>([]);
  const [destinationTasks, setDestinationTasks] = useState<IKeyValue[]>([]);
  const [searchParams, setSearchParams] = useState<IFilterMarque>();
  const [listfilter, setListFilter] = useState<IFilterMarque>();
  // const [listfilter, setListFilter] = useState<IFilterMarque>();

  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  //const [facettes, setFacettes] = useState<IFacetteFiltre[]>([]); // |null
  const [isDescending, setIsDescending] = useState<boolean|null>(null);
  const [sortField, setSortField] = useState("");
  const [numberOfResults, setNumberOfResults] = useState<number|null>(null);
  const [searchParamsMessage, setSearchParamsMessage] = useState<IFilterMessage>();

  useEffect(() => {
    const _filter: IFilterMessage = filterToQueryMessage({
      IdTypereponses: [Type_Reponse_Message.Nouveau,Type_Reponse_Message.TraitementEnCours],
      Offset:0,
      Limit: 1 // to be fast
    });
    setSearchParamsMessage(_filter);
  }, [])

  const { data: SocietesResult, isFetching, error} = useFetchSocietesByIdsQuery(searchParams, {
      refetchOnMountOrArgChange: true,
      skip: !keycloakinitialized || !keycloak.authenticated || searchParams === null || searchParams === undefined,
    });

    const { data: MessagesResult, isFetching: isFetchingMessages, error:errorMessages } = useFetchmessagesMarqueQuery(searchParamsMessage, {
      refetchOnMountOrArgChange: true,
      skip: !keycloakinitialized || !keycloak.authenticated || searchParamsMessage === null || searchParamsMessage === undefined,
    });
     
    const [
      updateSociete,
      {
      isSuccess: isSuccessUpdateSociete,
      error: errorUpdateSociete,
    }] = useSocieteCompteUpdateMutation();

    useEffect(() => {
      if (errorUpdateSociete !== undefined) {
        toast.warn("Les modifications n'ont pas été prises en compte");
        //setUpdateError(errorUpdateBO)
      }
  }, [errorUpdateSociete])
  
  useEffect(() => {
    if (isSuccessUpdateSociete) {
      toast.success("Les modifications ont bien été prises en compte.");
      // setPublication(publication);
      // setUpdateSuccess(true);
    }
  }, [isSuccessUpdateSociete])

    useEffect(() => {
      if (listfilter && listfilter !== getDefaultFilterMarque()) {
        const _filter: IFilterMarque = filterToQuery({
          ...listfilter,
          ...(sortField !== "" && { SortField: sortField }),
          ...(isDescending !== null && { IsDescending: isDescending }),
          ...(limit >= 10 && { Limit: limit }),
          ...(offset >= 0 && { Offset: offset }) //&& limit > 0 && { Offset: Math.floor(offset / limit) +1 })
        });

        setSearchParams(_filter);
        localStorage.setItem("IFilterMarques",JSON.stringify(_filter));
      }
    }, [listfilter, sortField, isDescending,offset, limit]); 
    

    useEffect(() => {
      const storedFilter = localStorage.getItem("IFilterMarques");
      //const storedSorter = localStorage.getItem("ISortStore");
      if (storedFilter !== null && storedFilter !== undefined) { // && storedSorter !== null && storedSorter !== undefined) {
        const filters = JSON.parse(storedFilter);
        setListFilter(filters);
        setOffset(filters.Offset ?? 0)
        setLimit(filters.Limit ?? 10)
      } else {
        setListFilter(getDefaultFilterMarque());
      }
    
      
    }, []);
    useEffect(() => {
      if (SocietesResult?.Return_IdType_Message === Type_Return_Message.Erreur) {
        toast.error(SocietesResult?.Return_Message);
      } else {
        if (SocietesResult) {
          setNumberOfResults(SocietesResult?.Quantite ?? null);
          setSourceTasks([]);
          setDestinationTasks([]);

          SocietesResult?.Societes.map((elem :any) => {
              setSourceTasks((prevTasks) => [
                  ...prevTasks,
                  { key: elem.IdSociete.toString(), value: "(" + elem.IdSociete.toString() + ")&nbsp;<b>" + elem.RaisonSociale + "</b>" }
                ]);
          });
          localStorage.setItem("MarquesNavigator", JSON.stringify(SocietesResult?.Societes?.map(n => ({ idmarque: n.Id }))));
        }
      }
    }, [SocietesResult])

 
    
    const applyFilter = (data: IFilterMarque) => {
       setListFilter(data);
        setOffset(0);
        setLimit(10);
    }
    useEffect(() => {
      if (SocieteCompteResult && SocieteCompteResult.Societe && !hasResetFormRef.current) {
        resetOrganisation({
          Siren: SocieteCompteResult?.Societe?.Siren,
          RaisonSocialeSiren: SocieteCompteResult?.Societe?.RaisonSociale,
          RaisonSociale : SocieteCompteResult?.Societe?.RaisonSociale,
          IdTypeCompteSociete: SocieteCompteResult?.Societe?.IdTypeCompteSociete,
          SiteInternet : SocieteCompteResult?.Societe?.SiteInternet,
          Adresse: SocieteCompteResult?.Societe?.Adresse,
          CodePostal: SocieteCompteResult?.Societe?.CodePostal,
          IdPays: SocieteCompteResult?.Societe?.IdPays,
          Ville: SocieteCompteResult?.Societe?.Ville,
          IdSecteurActivite: SocieteCompteResult?.Societe?.IdSecteurActivite,
        });
        
        hasResetFormRef.current = true;
        // Marquer comme initialisé pour déclencher la validation SIREN
        setTimeout(() => setIsInitialized(true), 100);
      }
    }, [SocieteCompteResult, resetOrganisation])

    const actions: ILocation[] = [
      {
        PathsName: { Voir: "/monorganisation/marquedetails/[[Id]]" },
        State: { type_access: "" },
        ClassName: "bi-receipt fs-5 mb-2",
      },
      {
        PathsName: (index) => { 
          const nbDemande = SocietesResult?.Societes[index]?.DemandesMessages ?? 0;
          const statut = nbDemande > 0 ? ` (${nbDemande} en cours)` : "";
          const lbl = `Suivi modifications société ${statut}`;
          return { [lbl] : "/monorganisation/marquedetailsmessage/[[Id]]" }
        },

        State: { type_access: "" },
        ClassName: (index) => {
          const classname = ( SocietesResult?.Societes[index]?.DemandesMessages ?? 0) > 0 ? "bi-chat-left-text text-orange fs-5 mb-2" : "bi-chat-left-text fs-5 mb-2";
          return classname;
        },
      },
    ];
  
    const dataHeaderName: ITitle[] = [
      {
        Id: "IdSociete",
        Name: "IdSociete",
        Class: "",
        // sorter: (a: ISociete, b: ISociete) =>
        //   a?.IdSociete?.localeCompare(b?.IdSociete),
      },
      {
        Id: "RaisonSociale",
        Name: "Raison Sociale",
        Class: "",
        // sorter: (a: ISociete, b: ISociete) =>
        //   a?.RaisonSociale?.localeCompare(b?.RaisonSociale),
      },
      {
        Id: "Pays",
        Name: "Pays",
        Class: "",
        // sorter: (a: ISociete, b: ISociete) =>
        //   a?.Pays?.localeCompare(b?.Pays),
      },
      {
        Id: "Ville",
        Name: "Ville",
        Class: "",
        // sorter: (a: ISociete, b: ISociete) =>
        //   a?.Ville?.localeCompare(b?.Ville),
      },
      {
        Id: "CodePostal",
        Name: "Code Postal",
        Class: "",
        // sorter: (a: ISociete, b: ISociete) =>
        //   a?.CodePostal?.localeCompare(b?.CodePostal),
      },
      {
        Id: "ISBN",
        Name: "ISBN",
        Class: "",
        // sorter: (a: ISociete, b: ISociete) =>
        //   a?.ISBN?.localeCompare(b?.ISBN),
      },
    ];
  
  
    const dataItemsStyle = {
      IdSociete: "",
      RaisonSociale: "",
      Pays: "",
      Ville: "",
      CodePostale: "",
      ISBN: "",
    };
    const navigate = useNavigate();

    // Active Tabs 
    const [activeTab, setActiveTab] = useState<string>("");

  useEffect(() => {
    // Get the saved tab from localStorage or default to 'home'
    const savedTab = localStorage.getItem('activeTab') || 'home'; // Default to 'home'
    setActiveTab(savedTab);
  }, []);

  const handleTabSelect = (selectedTab : any) => {
    // Set the selected tab and save it to localStorage
    setActiveTab(selectedTab);
    localStorage.setItem('activeTab', selectedTab);
  };

 const clickFacettteMessageMarque = () => {
    const combinedData: IFilterMessage = {
      IdTypereponses: [
        Type_Reponse_Message.Nouveau,
        Type_Reponse_Message.TraitementEnCours
      ]
    };
    localStorage.setItem("IFilterMessagesMarque",JSON.stringify(combinedData));
    navigate("/messagesmarques")
   }
  
  return (
    <div className="container text-center">
      <div className="row pt-3 pb-5">
        <div className="col col-12 ">
          <h2 className="titreModule titre-bleu"><i className="bi-buildings pe-2" />Mon Organisation</h2>
        </div>
      </div>
      <Tabs activeKey={activeTab} onSelect={handleTabSelect} id="uncontrolled-tab-example" className="onglet mb-3">


        <Tab eventKey="home" title="Mes informations générales">

        {SocieteCompteisFetching ? (
          <SpinnerEditeurPro />
  ) : SocieteCompteerror ? (
    <div>Error</div>
  ) : (
    <>
      <div className="row pt-3 pb-4">
        <div className="col col-md-10 offset-md-1 col-12 ">
        <FormProvider {...formMethodsOrganisation}>
            <form onSubmit={handleSubmitOrganisation((data) => onSubmitOrganisation(data),onErrorOrganisation)}>
              <CpntForm>
                <CpntFormSection pSectionLabel="Information sur la raison sociale">
                      <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6,6,6,6,6,6,6,6,6]}>
                      {(() => {
                        const hasSiren = SocieteCompteResult?.Societe?.Siren && SocieteCompteResult?.Societe?.Siren !== "" && SocieteCompteResult?.Societe?.Siren !== "0";
                        const isSirenDisabled = !SocieteCompteResult?.Societe?.AdminSociete || !!hasSiren;
                        
                        return watchIdPays && FRANCE_ET_ASSIMILES_IDS.includes(Number(watchIdPays)) && (
                        <>
                          <TextInput
                            label="N° Siren"
                            formName="Siren"
                            validationStyle={validationMode.classic}
                            placeholder="Numéro SIREN (9 chiffres)"
                            ismandatory={true}
                            disabled={isSirenDisabled}
                          />
                          <TextInput
                            label="Raison sociale (SIREN)"
                            formName="RaisonSocialeSiren"
                            validationStyle={validationMode.classic}
                            placeholder="Récupérée automatiquement"
                            disabled={true}
                          />
                        </>
                      );
                      })()}
                       <SelectInput
                        disabled={true}
                          label="Type compte société"
                          formName="IdTypeCompteSociete"
                          ismandatory={true}
                          options={TypeCompteSociete.map((tc) => {
                            return {
                              Id: tc.Id,
                              Libelle: tc.Libelle,
                              //defaultChecked: civ.Id,
                            };
                          })}
                        />
                        <SelectInput
                        disabled={!SocieteCompteResult?.Societe?.AdminSociete}
                          label="Secteur d’activité"
                          formName="IdSecteurActivite"
                          ismandatory={true}
                          options={secteurActivites?.SecteurActivites?.map((tc) => {
                            return {
                              Id: tc.Id,
                              Libelle: tc.Libelle,
                              //defaultChecked: civ.Id,
                            };
                          })}
                          
                        />
                        <TextInput
                        disabled={!SocieteCompteResult?.Societe?.AdminSociete}
                          label="Nom"
                          formName="RaisonSociale"
                          validationStyle={validationMode.classic}
                          placeholder="Nom"
                          ismandatory={true}
                        />
                        <TextInput
                        disabled={!SocieteCompteResult?.Societe?.AdminSociete}
                          label="Site internet"
                          formName="SiteInternet"
                          validationStyle={validationMode.classic}
                          placeholder="Site internet"
                          ismandatory={false}
                        />
                        <TextInput
                        disabled={!SocieteCompteResult?.Societe?.AdminSociete}
                          label="Adresse postale"
                          formName="Adresse"
                          validationStyle={validationMode.classic}
                          placeholder="Adresse postale"
                          ismandatory={true}
                        />
                         <TextInput
                         disabled={!SocieteCompteResult?.Societe?.AdminSociete}
                          label="Ville"
                          formName="Ville"
                          validationStyle={validationMode.classic}
                          placeholder="Ville"
                          ismandatory={true}
                        />
                         <TextInput
                         disabled={!SocieteCompteResult?.Societe?.AdminSociete}
                          label="Code postal"
                          formName="CodePostal"
                          validationStyle={validationMode.classic}
                          placeholder="Code postal"
                          ismandatory={false}
                          maxLength={11}
                        />
                        <SelectInput
                        disabled={!SocieteCompteResult?.Societe?.AdminSociete}
                          label="Pays"
                          formName="IdPays"
                          ismandatory={true}
                          options={pays?.Pays?.map((pays) => {
                            return {
                              Id: pays.Id,
                              Libelle: pays.Libelle,
                            };
                          })}
                        />
                      </CpntFormSectionContainer>
                      <CpntFormSectionNavigation>
                        {/* <div></div> */}
                        {SocieteCompteResult?.Societe?.AdminSociete && 
                         <Button type="submit" className="btn-secondary col-12">
                         Enregistrer
                       </Button>
                        }
                       
                        {/* <div></div> */}
                      </CpntFormSectionNavigation>

                </CpntFormSection>
              </CpntForm>
            </form>
          </FormProvider>
        </div>
        </div>
        <div className="row pt-1 pb-5">
          <div className="col col-md-5 offset-md-1 col-12 "> 
            <div className="card form-card">
              <div className="card-body form-container text-start">
              <div className=""><p className="h6lpe"><b>Les services de mon organisation</b></p></div>
              {
                ModulesList.map((mod) => (
                    // eslint-disable-next-line no-constant-condition
                    <><span>{mod.Libelle}</span> : <b>{ SocieteCompteResult?.Societe?.Modules?.find(mid => mid === mod.Id) ? <i style={{padding: "0px 5px"}} className="text-green">Actif</i> : <i style={{padding: "0px 5px"}} className="text-redlight">Inactif</i>}</b><br/></>
                ))
              }
              </div>
            </div>
          </div>
          <div className="col col-md-5 col-12">
            <div className="card form-card">
              <div className="card-body form-container text-start">
             <div className="">
              <Label className="h6lpe" label="L&apos;administrateur de mon organisation" popover="Pour un changement d'administrateur veuillez contacter votre chargé(e) de relations éditeurs." />
                </div>
                {SocieteCompteResult?.Societe?.Administrateur && (
                  <>
                  <b>{SocieteCompteResult?.Societe?.Administrateur?.Nom}</b> {SocieteCompteResult?.Societe?.Administrateur?.Prenom}<br />
                  <b>Coordonnées :</b><br />
                  {SocieteCompteResult?.Societe?.Administrateur?.Email} / {SocieteCompteResult?.Societe?.Administrateur?.Telephone}
                  </>
                )}
              </div>
            </div>
          </div>


        </div>
        </>
            )}
        </Tab>
        <Tab eventKey="profile" title="Mes informations commerciales">

            <div style={{marginTop:"50px", marginBottom:"50px"}}>
                {errorMessages && <div>Error</div>}
                {<CpntFacette  
                      Libelle="Suivi modifications société"
                      Quantite={MessagesResult?.Quantite ?? 0}
                      SkeletonVisible={(isFetchingMessages || !MessagesResult) ? true : false}
                      cssClassOuterBox="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
                      cssClassInnerBox="facette-color-notification"
                      FacetteSelected={false} 
                      onChange={clickFacettteMessageMarque} 
                        />}
              </div>
             {sourceTasks && destinationTasks &&
            <>
            <div className="row pt-3 pb-5">
              <div className="col-12 ">
              {searchParams && (
            <>
              <MarquesFilter
                filter={dtoToFilter(searchParams)}
                changeFilter={applyFilter}
              />
            </>
          )}
            {/* <CpntDragAndDropLists titresource="Disponible" source={sourceTasks} titredestination="Affecté" destination={destinationTasks} setDestinationValue={setDestinationResult}/> */}
            </div>
            </div>
            <div className="row ">
          
            </div>
          {isFetching ? (
          <SpinnerEditeurPro />
          ) : error ? (
            <div>Error</div>
          ) : (
            numberOfResults !== null && SocietesResult?.Societes && 
              <>
                <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                  <div className="col-1.5" style={{margin:"5px"}}>
                Nombre total de société(s): <b>{numberOfResults}</b>
                  </div> 
                </div>
                <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>
                <div className="card p-0 mb-2">
                  <div className="table-responsive">
                    <CpntDataTable
                      data={SocietesResult && SocietesResult.Societes ? [...SocietesResult.Societes] : []}
                      dataHeader={dataHeaderName}
                      dataItemsStyle={dataItemsStyle}
                      actions={actions}
                      actualFilterPage="PageMarques"
                      updateSorter={setSortField}
                      updateDescending={setIsDescending}
                  />
                  </div>
                </div>
                <CpntPagination limit={limit} offset={offset} numberOfResults={numberOfResults} setLimit={(Limit) => setLimit(Limit)} setOffset={(offset) => setOffset(offset)}></CpntPagination>
              </>
          )}
        </>
        }

  </Tab>
</Tabs>
      
    </div>
  );
};

export default PageMonOrganisation;
